import { Button, Col, Container, Form, Row } from "react-bootstrap";
import LogoHeader from "../logoHeader/logoHeader";
import { FormEvent, useEffect, useState } from "react";
import { KundeData } from "./kundeData";
import { DataHandler } from "../dataHandler";
import { useNavigate, useParams } from "react-router-dom";
import ModalAlert from "../sharedComponents/modalAlert";

export default function Kunden() {

    const [validated, setValidated] = useState(false);
    const [loadedFormData, setLoadedFormData] = useState<KundeData>();
    const [failed, setFailed] = useState<string | undefined>();
    const [success, setSuccess] = useState<string | undefined>();
    const [formDataLoadingRunning, setFormDataLoadingRunning] = useState(false);

    const navigate = useNavigate();

    let formdata: KundeData | null;
    if (loadedFormData === undefined)
        formdata = null;
    else
        formdata = loadedFormData;

    const handleDataError = (error: any, defaultmessage: string) => {
        debugger;
        if (error.message)
            defaultmessage = error.message;
        if (error.response?.data)
            defaultmessage += '\r\n ' + error.response.data;

        setFailed(defaultmessage);
    }

    const clearForm = () => {
        setFormDataLoadingRunning(false);
        setLoadedFormData(undefined);
    }


    const abbrechen = () => {
        navigate("/");
    }

    const { id } = useParams();
    let idNumber = -1;
    if (id)
        idNumber = parseInt(id);

    useEffect(() => {
        if (idNumber > 0 && formDataLoadingRunning === false) {
            setFormDataLoadingRunning(true); // Loading
            const promise = DataHandler.getKunde(idNumber);
            promise.then((data) => {
                setLoadedFormData(data);
            }).catch((error) => {
                handleDataError(error, "Kunde konnte nicht geladen werden.")
            });
        }
    }, []);

    const submit = (eventArgs: FormEvent) => {
        eventArgs.preventDefault();
        eventArgs.stopPropagation();
        const form = eventArgs.target as HTMLFormElement;
        let valid = form.checkValidity();
        setValidated(true);

        if (valid) {

            const data = new FormData(form);

            const done = (data: any) => {
                if (data.status === 200) {
                    clearForm();
                    navigate("/kundeList")
                    setSuccess("Kunde gespeichert");
                }
            };
            const failed = (error: any) => {
                const message = "Fehler beim Speichern des Kunden.";
                handleDataError(error, message);

            };

            DataHandler.sendKunde(data, done, failed);
        }
        else {
            debugger;
            const firstInvalidElement = form.querySelector(':invalid');
            if (firstInvalidElement)
                firstInvalidElement.scrollIntoView();
        }


    };

    const inputTextRowsXs = "auto";

    const getNowDateString = () => {
        const dt = new Date();
        return dt.getFullYear() + '-' + (dt.getMonth() + 1).toString().replace(/^(\d)$/, '0$1') + '-' + dt.getDate().toString().replace(/^(\d)$/, '0$1');
    }

    return <div className="kunde">
        {failed && <ModalAlert callback={() => setFailed(undefined)} content={failed} contentTitle="Fehler" variant="danger"></ModalAlert>}
        {success && <ModalAlert callback={() => setSuccess(undefined)} content={success} contentTitle="" variant="info"></ModalAlert>}
        <Container fluid >
            <LogoHeader />
            <Form noValidate validated={validated} onSubmit={submit}>
                <Row s>
                    <Col xs="12" sm="5">

                        <Row>
                            <Col>
                                <h1>Kunde anlegen</h1>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Firmenname</Form.Label>
                        <Form.Control defaultValue={formdata?.json.firmenname} required type="text" name="firmenname" placeholder="Firmenname"></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Firmenname muss angegeben werden.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Ansprechperson</Form.Label>
                        <Form.Control defaultValue={formdata?.json.ansprechperson} required type="text" name="ansprechperson" placeholder="Ansprechperson"></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Ansprechperson muss angegeben werden.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Straße mit Hausnummer</Form.Label>
                        <Form.Control defaultValue={formdata?.json.strasse} required type="text" name="strasse" placeholder="Straße mit Hausnummer"></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Straße mit Hausnummer muss angegeben werden.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Ort</Form.Label>
                        <Form.Control defaultValue={formdata?.json.ort} required type="text" name="ort" placeholder="Ort"></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Ort muss angegeben werden.
                        </Form.Control.Feedback>
                    </Form.Group>

                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control defaultValue={formdata?.json.email} type="text" name="email" placeholder="Email"></Form.Control>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Telefonnummer</Form.Label>
                        <Form.Control defaultValue={formdata?.json.telefonnummer} type="text" name="telefonnummer" placeholder="Telefonnummer"></Form.Control>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Bearbeiter</Form.Label>
                        <Form.Control defaultValue={formdata?.json.bearbeiter} type="text" name="bearbeiter" placeholder="Bearbeiter"></Form.Control>
                    </Form.Group>
                </Row>
                <Row xs={inputTextRowsXs}>
                    <Form.Group>
                        <Form.Label>Erfassungsdatum</Form.Label>
                        <Form.Control defaultValue={formdata?.json.date || getNowDateString()} type="datetime-local" name="date" placeholder="Erfassungsdatum"></Form.Control>
                    </Form.Group>
                </Row>
                <Row className="gy-5">
                    {idNumber === -1 && <Col xs={6} >
                        <Form.Group>
                            <div style={{ paddingTop: '1em' }}>
                                <Button variant="primary" type="submit">Anlegen</Button>
                            </div>
                        </Form.Group>
                    </Col>}
                    <Col xs={6} >
                        <div style={{ paddingTop: '1em' }}>
                            <Button variant="secondary" type="button" onClick={abbrechen}>{idNumber === -1 ? 'Abbrechen' : 'Schließen'}</Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Container>
    </div>
}